export const injectUndefinedBreakdown = (datasets, label, byStage, totals, white) => {
  const { declined: declinedToUse, unknown: unknownToUse } = byStage.value;
  const keyMap = {
    Application: 'review',
    Screening: 'screen',
    Assessment: 'assessment',
    Offer: 'offer',
    Hired: 'hired',
  };

  const key = keyMap[label];
  if (!key) return datasets;

  const total = totals.value[key] || 1;
  const declinedValue = ((declinedToUse?.[key] || 0) / total) * 100;
  const unknownValue = ((unknownToUse?.[key] || 0) / total) * 100;

  const datasetIndex = datasets.findIndex((dataset) => dataset.value.endsWith('Undefined'));
  if (datasetIndex === -1) return datasets;

  const undefinedDataset = datasets[datasetIndex];

  const makeTableRow = (data, datasetLabel) => ({
    value: `${data.toFixed(1)}% ${datasetLabel}`,
    color: white.value,
    isBold: undefinedDataset.isBold,
    isIndented: true,
    data,
  });

  const inserts = [
    makeTableRow(declinedValue, 'Declined'),
    makeTableRow(unknownValue, 'Not Submitted'),
  ].sort((a, b) => b.data - a.data);

  datasets.splice(datasetIndex + 1, 0, ...inserts);

  return datasets;
};
